export enum TattooCategory {
	HEAD = 'head',
	NECK = 'neck',
	ARM_RIGHT = 'arm_right',
	ARM_LEFT = 'arm_left',
	BREAST = 'breast',
	BELLY = 'belly',
	BACK_BODY = 'back_body',
	LEG_RIGHT = 'leg_right',
	LEG_LEFT = 'leg_left',
}
